(() => {
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const setupFaqAccordion = (list) => {
    if (list.dataset.faqAccordionInit === "1") return;
    list.dataset.faqAccordionInit = "1";

    const triggers = list.querySelectorAll("[data-faq-trigger]");
    const panels = list.querySelectorAll("[data-faq-panel]");

    const closeAll = () => {
      triggers.forEach((trigger) => trigger.setAttribute("aria-expanded", "false"));
      panels.forEach((panel) => panel.classList.remove("is-open"));
    };

    triggers.forEach((trigger, index) => {
      trigger.addEventListener("click", () => {
        const panel = panels[index];
        if (!panel) return;

        const isOpen = trigger.getAttribute("aria-expanded") === "true";
        closeAll();

        if (!isOpen) {
          trigger.setAttribute("aria-expanded", "true");
          panel.classList.add("is-open");
        }
      });
    });
  };

  const easeOutCubic = (t) => 1 - (1 - t) ** 3;

  let scrollRaf = null;
  const updateScrollReveal = () => {
    scrollRaf = null;
    if (prefersReducedMotion) return;

    document.querySelectorAll("[data-faq-scroll-root]").forEach((section) => {
      const items = section.querySelectorAll("[data-faq-scroll-item]");
      if (!items.length) return;

      const rect = section.getBoundingClientRect();
      const vh = window.innerHeight || 1;
      const denom = vh + Math.max(rect.height, 1);
      const p = Math.min(1, Math.max(0, (vh - rect.top) / denom));

      const n = items.length;
      const spreadEnd = Math.min(0.88, 0.28 + n * 0.09);
      const band = Math.max(0.1, spreadEnd / Math.max(n, 1));

      items.forEach((el, i) => {
        const start = (i / Math.max(1, n - 1)) * spreadEnd * 0.92;
        let t = (p - start) / band;
        t = Math.min(1, Math.max(0, t));
        t = easeOutCubic(t);

        const y = (1 - t) * 52;
        const rot = (1 - t) * -5;
        el.style.opacity = String(Math.min(1, t * 1.02));
        el.style.transform = `translate3d(0, ${y.toFixed(2)}px, 0) rotateX(${rot.toFixed(2)}deg)`;
        el.style.transformOrigin = "50% 0%";
      });
    });
  };

  const scheduleScrollReveal = () => {
    if (prefersReducedMotion) return;
    if (scrollRaf != null) return;
    scrollRaf = requestAnimationFrame(updateScrollReveal);
  };

  const init = () => {
    document.querySelectorAll("[data-faq-list]").forEach(setupFaqAccordion);
    if (!prefersReducedMotion) {
      window.addEventListener("scroll", scheduleScrollReveal, { passive: true });
      window.addEventListener("resize", scheduleScrollReveal, { passive: true });
      scheduleScrollReveal();
    }
  };

  init();

  document.addEventListener("shopify:section:load", (event) => {
    const root = event.target;
    if (!root || typeof root.querySelectorAll !== "function") return;
    root.querySelectorAll("[data-faq-list]").forEach((list) => {
      delete list.dataset.faqAccordionInit;
      setupFaqAccordion(list);
    });
    scheduleScrollReveal();
  });
})();
